"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dimensions_1 = __importDefault(require("../dimensions"));

var cut_outs_1 = require("../cut-outs");

var lodash_1 = require("lodash");

var plate_element_1 = require("./plate-element");

var PlateElementsBuilder =
/** @class */
function () {
  function PlateElementsBuilder(conf, plate) {
    var _this = this;

    this.buildPlate = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'plate';
      var merged = lodash_1.merge({
        type: type,
        materialName: _this.conf.surface && _this.conf.surface.color
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildGelCoat = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'gelcoat';
      var merged = lodash_1.merge({
        type: type,
        position: {
          y: _this.plate.sides.bottom,
          x: _this.plate.position.x,
          z: _this.plate.position.z
        },
        scale: {
          x: _this.plate.scale.x,
          y: 1,
          z: _this.plate.scale.z
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildSticker = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'sticker';
      var cornerDesign = _this.conf.washBasinDimension && _this.conf.washBasinDimension.cornerDesign;
      var cornerWidth = cornerDesign && _this.conf.hasLeftCorner ? dimensions_1.default.techSpecs.distance.cornerDesign[cornerDesign] : 0;
      var merged = lodash_1.merge({
        type: type,
        position: {
          y: _this.plate.position.y,
          x: _this.plate.sides.left + 25 + 10 + cornerWidth,
          z: _this.plate.sides.back
        },
        scale: {
          x: 50,
          y: _this.plate.scale.y,
          z: 1
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildTissueDispenser = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'cut-out';
      var subType = 'tissue-dispenser';
      var merged = lodash_1.merge({
        type: type,
        subType: subType,
        position: {
          y: _this.plate.sides.top - 75,
          z: _this.plate.sides.front - _this.dimensions.techSpecs.apronThickness / 2
        },
        scale: {
          x: _this.dimensions.installaionParts.tissueDispenserWidth,
          y: _this.dimensions.installaionParts.tissueDispenserHeight
        },
        elements: _this.buildTissueDispenserElements()
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildTissueDispenserElements = function () {
      var hole = new plate_element_1.PlateElement(lodash_1.merge({
        type: 'tissue-dispenser-hole',
        shape: 'box',
        fileName: 'tissue-dispenser-hole',
        scale: {
          x: _this.dimensions.installaionParts.tissueDispenserCutWidth,
          y: _this.dimensions.installaionParts.tissueDispenserCutHeight,
          z: 20 // this.dimensions.techSpecs.apronThickness + 2

        },
        isSubstraction: true
      }));
      var container = new plate_element_1.PlateElement(lodash_1.merge({
        type: 'tissue-dispenser-container',
        fileName: 'cosmetic_despender_neu'
      }));
      return [hole, container];
    };

    this.buildPlain = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var element = new plate_element_1.PlateElement(overrides);
      return element;
    };

    this.buildWidthApron = function (overrides, height) {
      if (overrides === void 0) {
        overrides = {};
      }

      var merged = lodash_1.merge(__assign({}, _this.buildDepthApron(overrides, height), {
        subType: 'width',
        position: {
          x: _this.plate.position.x,
          y: _this.plate.sides.top - height / 2,
          z: _this.plate.sides.front - _this.dimensions.techSpecs.apronThickness / 2
        },
        scale: {
          x: _this.plate.scale.x,
          y: height,
          z: _this.dimensions.techSpecs.apronThickness
        }
      }), overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildWidthBackSplash = function (overrides, height) {
      if (overrides === void 0) {
        overrides = {};
      }

      var merged = lodash_1.merge(__assign({}, _this.buildDepthBackSplash(overrides, height), {
        position: {
          x: _this.plate.position.x,
          y: _this.plate.sides.top + height / 2,
          z: _this.plate.sides.back + _this.dimensions.techSpecs.backSplashThickness / 2
        },
        scale: {
          x: _this.plate.scale.x,
          y: height,
          z: _this.dimensions.techSpecs.backSplashThickness
        }
      }), overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildWidthSurgeEdge = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var merged = lodash_1.merge(__assign({}, _this.buildDepthSurgeEdge(overrides), {
        position: {
          x: _this.plate.position.x,
          y: _this.plate.sides.top + _this.dimensions.techSpecs.surgeEdgeHeight / 2,
          z: _this.plate.sides.back + _this.dimensions.techSpecs.surgeEdgeThickness / 2
        },
        scale: {
          x: _this.plate.scale.x,
          y: _this.dimensions.techSpecs.surgeEdgeHeight,
          z: _this.dimensions.techSpecs.surgeEdgeThickness
        }
      }), overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildDepthApron = function (overrides, height) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'apron';
      var buffer = _this.dimensions.installaionParts.buffers.apron;
      var merged = lodash_1.merge({
        type: type,
        shape: 'box',
        subType: 'depth',
        materialName: _this.conf.surface && _this.conf.surface.color,
        position: {
          x: 0,
          y: _this.plate.sides.top - height / 2,
          z: _this.plate.position.z
        },
        scale: {
          x: _this.dimensions.techSpecs.apronThickness,
          y: height,
          z: _this.plate.scale.z
        },
        buffer: {
          left: overrides && overrides.isLast ? buffer.left : 0,
          right: overrides && overrides.isFirst ? buffer.right : 0
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildDepthBackSplash = function (overrides, height) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'back-splash';
      var merged = lodash_1.merge({
        behaviour: 'absolute',
        type: type,
        shape: 'box',
        materialName: _this.conf.surface && _this.conf.surface.color,
        position: {
          x: 0,
          y: _this.plate.sides.top + height / 2,
          z: _this.plate.scale.z / 2
        },
        scale: {
          x: _this.dimensions.techSpecs.backSplashThickness,
          y: height,
          z: _this.plate.scale.z
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildDepthSurgeEdge = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'surge-edge';
      var merged = lodash_1.merge({
        behaviour: 'absolute',
        type: type,
        shape: 'box',
        materialName: _this.conf.surface && _this.conf.surface.color,
        position: {
          x: 0,
          y: _this.plate.sides.top + _this.dimensions.techSpecs.surgeEdgeHeight / 2,
          z: _this.plate.scale.z / 2
        },
        scale: {
          x: _this.dimensions.techSpecs.surgeEdgeThickness,
          y: _this.dimensions.techSpecs.surgeEdgeHeight,
          z: _this.plate.scale.z
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildCutOut = function (overrides, selectedCutOut, railDepthOffset) {
      if (overrides === void 0) {
        overrides = {};
      }

      if (railDepthOffset === void 0) {
        railDepthOffset = 0;
      }

      var type = 'cut-out';
      var subType = selectedCutOut.key === 'PROVIDER' ? 'dispenser' : 'disposal';
      var merged = lodash_1.merge({
        type: type,
        subType: subType,
        position: {
          y: _this.plate.sides.top + 1
        },
        buffer: selectedCutOut.buffer,
        scale: {
          x: selectedCutOut && selectedCutOut.reqDimensions.width,
          z: selectedCutOut && selectedCutOut.reqDimensions.depth
        },
        elements: _this.buildCutOutElements(selectedCutOut, _this.plate, railDepthOffset)
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildConsole = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'console';
      var consoleType = _this.conf.selectedConsole;
      var consoleWidth = _this.dimensions.installaionParts.consoles[consoleType].min;
      var consoleBuffer = _this.dimensions.installaionParts.buffers[consoleType]; // const consoleBuffer =  this.dimensions.installaionParts.buffers[consoleType];

      var consoleLength = 450;

      if (_this.conf.washBasinDimension && _this.conf.washBasinDimension.plateDepth <= 480) {
        consoleLength = 370;
      }

      var isEdgeConsole = overrides && overrides.isFirst || overrides && overrides.isLast;
      var bufferLeft = 0;
      var bufferRight = 0;

      if (overrides && overrides.isFirst && !_this.conf.hasLeftCorner) {
        bufferLeft = 10;
      } else if (consoleType === 'miranit' && !isEdgeConsole) {
        bufferLeft = consoleBuffer.left;
      }

      if (overrides && overrides.isLast && !_this.conf.hasRightCorner) {
        bufferRight = 10;
      } else if (consoleType === 'miranit' && !isEdgeConsole) {
        bufferRight = consoleBuffer.right;
      }

      var merged = lodash_1.merge({
        type: type,
        fileName: consoleType === 'miranit' ? 'uhalter_miranit' : consoleLength === 450 ? 'uhalter' : 'uhalter_short',
        materialName: consoleType === 'miranit' ? 'white' : consoleType,
        position: {
          y: _this.plate.sides.bottom,
          z: _this.plate.sides.back
        },
        scale: {
          x: consoleWidth,
          y: 150,
          z: consoleLength
        },
        buffer: {
          left: bufferLeft,
          right: bufferRight
        },
        elements: _this.buildFasteningElements(consoleType, consoleLength)
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildConsoleCenterAnchor = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'consolecenteranchor';
      var merged = lodash_1.merge({
        type: type,
        position: {
          y: _this.plate.sides.bottom,
          z: _this.plate.sides.back
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildFasteningElements = function (consoleType, consoleLength) {
      var type = 'fastening';
      var fasteningElements = [];

      if (consoleType === 'miranit') {
        fasteningElements.push(new plate_element_1.PlateElement({
          type: type,
          position: {
            x: -60,
            y: -20,
            z: 50
          }
        }));
        fasteningElements.push(new plate_element_1.PlateElement({
          type: type,
          position: {
            x: 60,
            y: -20,
            z: 50
          }
        }));
      } else {
        fasteningElements.push(new plate_element_1.PlateElement({
          type: type,
          position: {
            x: 0,
            y: -45,
            z: 50
          }
        }));
        fasteningElements.push(new plate_element_1.PlateElement({
          type: type,
          position: {
            x: 0,
            y: -90,
            z: 50
          }
        }));
      }

      return fasteningElements;
    };

    this.buildSoapDispenser = function (overrides, soapDispenserType, includeSideBuffer) {
      if (overrides === void 0) {
        overrides = {};
      }

      if (includeSideBuffer === void 0) {
        includeSideBuffer = false;
      }

      var type = 'soap-dispenser';
      var tapDrillHoleDistanceToTrough = 0;

      if (includeSideBuffer && _this.conf.selectedTrough) {
        var drillHoleDistToCenter = _this.conf.selectedTrough.trough.drillHoleDistToCenter;
        var troughWidth = _this.conf.selectedTrough.trough.reqWidth;
        tapDrillHoleDistanceToTrough = drillHoleDistToCenter ? drillHoleDistToCenter - troughWidth / 2 - dimensions_1.default.techSpecs.drillHoles.soapDispenser / 2 : 0;
      }

      var fileName;

      switch (soapDispenserType) {
        case 'SD100':
          fileName = 'sd100';
          break;

        case 'SD80':
          fileName = 'tmp_soapdespender';
          break;
      }

      var merged = lodash_1.merge({
        type: type,
        materialName: !fileName && 'plainBlack',
        fileName: fileName,
        shape: 'cylinder',
        position: {
          x: 0,
          y: _this.plate.sides.top,
          z: 0
        },
        scale: {
          x: _this.dimensions.techSpecs.drillHoles.soapDispenser,
          y: 2,
          z: _this.dimensions.techSpecs.drillHoles.soapDispenser
        },
        buffer: {
          right: _this.dimensions.techSpecs.drillHoleBuffers.soapDispenser.right,
          left: tapDrillHoleDistanceToTrough ? tapDrillHoleDistanceToTrough : _this.dimensions.techSpecs.drillHoleBuffers.soapDispenser.left
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildTap = function (overrides, includeSideBuffer) {
      if (overrides === void 0) {
        overrides = {};
      }

      if (includeSideBuffer === void 0) {
        includeSideBuffer = false;
      }

      var type = 'tap';
      var tapDrillHoleDistanceToTrough = 0;

      if (includeSideBuffer && _this.conf.selectedTrough) {
        var drillHoleDistToCenter = _this.conf.selectedTrough.trough.drillHoleDistToCenter;
        var troughWidth = _this.conf.selectedTrough.trough.reqWidth;
        tapDrillHoleDistanceToTrough = drillHoleDistToCenter ? drillHoleDistToCenter - troughWidth / 2 - dimensions_1.default.techSpecs.drillHoles.tap / 2 : 0;
      }

      var merged = lodash_1.merge({
        type: type,
        fileName: 'am2_test',
        position: {
          x: 0,
          y: _this.plate.sides.top,
          z: 0
        },
        scale: {
          x: _this.dimensions.techSpecs.drillHoles.tap,
          y: 0,
          z: _this.dimensions.techSpecs.drillHoles.tap
        },
        buffer: {
          right: _this.dimensions.techSpecs.drillHoleBuffers.tap.right,
          left: tapDrillHoleDistanceToTrough ? tapDrillHoleDistanceToTrough : _this.dimensions.techSpecs.drillHoleBuffers.tap.left
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildTrough = function (overrides, selectedTrough, drillHoleAtBackEnabled) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'trough';
      var subType = selectedTrough.preparedBackWallWith ? 'backwall' : 'regular';
      var medcareExtraDepth = _this.conf.isMedcare ? 80 : 0;
      var backwallTroughEdge = 0 + (selectedTrough.plateDepth.min - selectedTrough.throughDepth - selectedTrough.distBetween) + medcareExtraDepth;
      var merged = lodash_1.merge({
        type: type,
        subType: subType,
        materialName: _this.conf.surface && _this.conf.surface.color,
        fileName: selectedTrough.fileName,
        position: {
          x: 0,
          y: _this.plate.sides.top,
          z: 0
        },
        buffer: {
          back: selectedTrough.preparedBackWallWith ? backwallTroughEdge : 0
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged); // Back side has 0 space for backwall trough, otherwise the back side is just distDrain=

      element.sidesFunction = function () {
        var adjustment = selectedTrough.preparedBackWallWith ? element.position.z : selectedTrough.distDrain;
        return {
          left: element.position.x - element.scale.x / 2,
          right: element.position.x + element.scale.x / 2,
          top: element.position.y,
          bottom: element.position.y + element.scale.y,
          back: element.position.z - adjustment,
          front: element.position.z - adjustment + element.scale.z
        };
      };

      Object.defineProperty(element, 'sides', {
        enumerable: true,
        get: element.sidesFunction
      });
      element.elements = _this.buildTroughElements(selectedTrough, element, drillHoleAtBackEnabled);
      return element;
    };

    this.buildAngleBar = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'angle-bar';
      var consoleType = _this.conf.selectedConsole;
      var hasApron = _this.conf.apronBackSplash && _this.conf.apronBackSplash.apron === 'with' && _this.conf.apronBackSplash.apronHeight;
      var plateDepthUnder = hasApron ? _this.plate.scale.z - _this.dimensions.techSpecs.apronThickness - _this.dimensions.techSpecs.apronBuffer : _this.plate.scale.z;
      var depthPosition = plateDepthUnder / 2;
      var merged = lodash_1.merge({
        type: type,
        fileName: 'uhalter_seite',
        materialName: consoleType === 'miranit' ? 'white' : consoleType,
        // Transform... will be passed in by override
        position: {
          x: 0,
          y: _this.plate.sides.bottom,
          z: depthPosition
        },
        scale: {
          x: _this.dimensions.installaionParts.angleBarWidth,
          y: _this.dimensions.installaionParts.angleBarWidth,
          z: _this.dimensions.installaionParts.angleBarLength
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildSafetyCatch = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'safety-catch';
      var consoleType = _this.conf.selectedConsole;
      var merged = lodash_1.merge({
        type: type,
        fileName: 'Abzugsicherung',
        materialName: consoleType === 'miranit' ? 'white' : consoleType,
        position: {
          y: _this.plate.sides.bottom,
          z: 40
        },
        scale: {
          x: _this.dimensions.installaionParts.safetyCatch,
          y: 33,
          z: 33
        },
        rotate: {
          x: 90
        }
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildCornerRadius = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'corner-radius';
      var cornerDesign = _this.conf.washBasinDimension && _this.conf.washBasinDimension.cornerDesign;
      var cornerDesignWidth = cornerDesign && dimensions_1.default.techSpecs.distance.cornerDesign[cornerDesign] || 0;
      var merged = lodash_1.merge({
        type: type,
        materialName: _this.conf.surface && _this.conf.surface.color,
        position: {
          y: _this.plate.position.y,
          z: _this.plate.sides.front - cornerDesignWidth
        },
        scale: {
          y: _this.plate.scale.y,
          x: cornerDesignWidth,
          z: cornerDesignWidth
        },
        thickness: _this.dimensions.techSpecs.apronThickness
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildSpacer = function (overrides) {
      if (overrides === void 0) {
        overrides = {};
      }

      var type = 'spacer';
      var merged = lodash_1.merge({
        type: type
      }, overrides);
      var element = new plate_element_1.PlateElement(merged);
      return element;
    };

    this.buildTroughElements = function (trough, troughElement, drillHoleAtBackEnabled) {
      // Populating the drain
      var elements = []; // Back hole

      if (drillHoleAtBackEnabled) {
        // const tapDrillHoleDepthPosition = trough.preparedBackWallWith ? 0 - troughElement.position.z + trough.distDrillHoleAtBack : -(trough.distDrain || 0) - (trough.distDrillHoleAtBack);
        var medcareExtraDepth = _this.conf.isMedcare ? 80 : 0;
        var troughDrainPosition = trough.preparedBackWallWith ? 0 - troughElement.position.z + (trough.plateDepth.min - trough.throughDepth - trough.distBetween) + trough.distDrain + medcareExtraDepth : 0; // non-prepared already starts at drain

        var tapDrillHoleDepthPosition = troughDrainPosition - trough.distDrain - trough.distDrillHoleAtBack; // Back tap

        if (_this.conf.builtInParts && _this.conf.builtInParts.tapHole) {
          elements.push(_this.buildTap({
            position: {
              y: 0,
              z: tapDrillHoleDepthPosition
            },
            isFirst: troughElement.isFirst,
            isLast: troughElement.isLast
          }));
        } // Soap dispenser


        if (troughElement && _this.conf.builtInParts && _this.conf.builtInParts.soapDispenserHole && _this.conf.builtInParts.soapDispenserHole !== 'without' && _this.conf.builtInParts.soapDispenserHolePositions && _this.conf.builtInParts.soapDispenserHolePositions.length > 0 && _this.conf.builtInParts.soapDispenserHolePositions[troughElement.troughIndex || 0] !== 'none') {
          var soapDispenserPosition = _this.conf.builtInParts.soapDispenserHolePositions[troughElement.troughIndex || 0];
          elements.push(_this.buildSoapDispenser({
            position: {
              x: soapDispenserPosition === 'left' ? -trough.soapDispenserWidth : trough.soapDispenserWidth,
              y: 0,
              z: tapDrillHoleDepthPosition + trough.soapDispenserDepth
            },
            rotate: {
              y: soapDispenserPosition === 'left' ? 40 : -40
            },
            isFirst: troughElement.isFirst,
            isLast: troughElement.isLast
          }, _this.conf.builtInParts.soapDispenserHole));
        }
      } // Drain


      {
        var drain = {
          type: 'drain',
          scale: {
            x: 46,
            y: 1,
            z: 46
          },
          position: {
            x: 0,
            y: -trough.throughHeight - 3,
            z: 0
          }
        }; // MZB drain

        if (_this.conf.isVariusMedMzb) {
          drain = lodash_1.merge(drain, {
            fileName: 'rohr',
            position: {
              x: troughElement.scale.x / 2 - trough.distDrain - 25,
              y: -trough.throughHeight + 1,
              z: 5
            }
          });
          elements.push(new plate_element_1.PlateElement(drain));
        }

        if (_this.conf.drainAccessories) {
          switch (_this.conf.drainAccessories.drain) {
            case 'hood-chrome':
              drain = lodash_1.merge(drain, {
                fileName: 'hood_chrome',
                position: {
                  y: drain.position.y + 5
                }
              });
              elements.push(new plate_element_1.PlateElement(drain));
              break;

            case 'hood':
              drain = lodash_1.merge(drain, {
                fileName: 'ABFLUSSDECKEL'
              });
              elements.push(new plate_element_1.PlateElement(drain));
              break;

            case 'sieve':
              drain = lodash_1.merge(drain, {
                fileName: 'ZANMW901_Siebablaufventil_2'
              });
              elements.push(new plate_element_1.PlateElement(drain));
              break;

            case 'eccentric':
              drain = lodash_1.merge(drain, {
                fileName: 'ABFLUSSDECKEL'
              });
              elements.push(new plate_element_1.PlateElement(drain));
              drain = lodash_1.merge(drain, {
                fileName: 'Z_ANMW902_shorter'
              });
              elements.push(new plate_element_1.PlateElement(drain));
              break;
          }
        }
      } // Siphon

      if (_this.conf.drainAccessories && _this.conf.drainAccessories.siphon) {
        var siphon = new plate_element_1.PlateElement({
          type: 'siphon',
          fileName: 'XINX140_Siphon_2000057417',
          scale: {
            x: 46,
            y: 100,
            z: 46
          },
          position: {
            x: 0,
            y: -trough.throughHeight - 20,
            z: 0
          }
        });
        elements.push(siphon);
      } // Towel rail


      if (_this.conf.builtInParts && _this.conf.builtInParts.towelRail) {
        var towelRail = new plate_element_1.PlateElement({
          type: 'towel-rail',
          fileName: 'towelrail',
          position: {
            x: 0,
            y: -92,
            z: _this.plate.sides.front - troughElement.position.z - _this.dimensions.techSpecs.apronThickness / 2
          },
          scale: {
            x: 400,
            y: 55
          },
          isSubstraction: true
        });
        elements.push(towelRail);
      }

      return elements;
    };

    this.conf = conf;
    this.plate = plate || new plate_element_1.PlateElement();
    this.dimensions = dimensions_1.default;
  }

  PlateElementsBuilder.prototype.buildCutOutElements = function (selectedCutOut, plate, railDepthOffset) {
    var elements = [];

    if (selectedCutOut) {
      var hole = new plate_element_1.PlateElement({
        type: 'cut-out-hole'
      });
      elements.push(hole);

      if (selectedCutOut.type === cut_outs_1.cutOutDisposalsType.Provider) {
        elements.push(new plate_element_1.PlateElement({
          type: 'cut-out-assembly',
          fileName: 'RODX600TT_turned'
        }));
      }

      if (selectedCutOut.withBasket) {
        elements.push(new plate_element_1.PlateElement({
          type: 'cut-out-trash',
          fileName: 'MUELLEIMER_BODEN'
        }));
      }

      if (selectedCutOut.withRail) {
        var trash = {};

        if (selectedCutOut.parts.includes('rail_150_withcosmetic')) {
          trash = {
            type: 'cut-out-trash',
            subType: 'rail_150_withcosmetic',
            fileName: 'trash_150'
          };
        } else if (selectedCutOut.parts.includes('rail_150')) {
          trash = {
            type: 'cut-out-trash',
            subType: 'rail_150',
            fileName: 'trash_150'
          };
        } else {
          trash = {
            type: 'cut-out-trash',
            subType: 'rail_60',
            fileName: 'trash_60'
          };
        }

        elements.push(new plate_element_1.PlateElement(trash)); // Fastenings...
        // Top left

        elements.push(new plate_element_1.PlateElement({
          type: 'fastening',
          position: {
            x: -125,
            z: railDepthOffset - 150
          }
        })); // Top right

        elements.push(new plate_element_1.PlateElement({
          type: 'fastening',
          position: {
            x: 125,
            z: railDepthOffset - 150
          }
        })); // Bottom left

        elements.push(new plate_element_1.PlateElement({
          type: 'fastening',
          position: {
            x: -125,
            z: railDepthOffset + 150
          }
        })); // Bottom right

        elements.push(new plate_element_1.PlateElement({
          type: 'fastening',
          position: {
            x: 125,
            z: railDepthOffset + 150
          }
        }));
      }

      if (selectedCutOut.shape === cut_outs_1.CutOutShapes.Flap) {
        elements.push(new plate_element_1.PlateElement({
          type: 'cut-out-assembly',
          fileName: 'RODX605TT_Abfall_Abwurfklappe_2000101211_neu'
        }));
      }

      if (selectedCutOut.withSleeve) {
        if (selectedCutOut.shape === cut_outs_1.CutOutShapes.Round) {
          elements.push(new plate_element_1.PlateElement({
            type: 'cut-out-assembly',
            fileName: 'hulse_rund'
          }));
        } else {
          elements.push(new plate_element_1.PlateElement({
            type: 'cut-out-assembly',
            fileName: 'RODX607TT_Abfall_Abwurfhuelse'
          }));
        }
      } // Set materials and positions...


      for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var element = elements_1[_i];

        switch (element.type) {
          case 'cut-out-hole':
            element.scale = {
              x: selectedCutOut.dimensions.width,
              y: plate.scale.y,
              z: selectedCutOut.dimensions.depth
            };
            element.position = {
              x: 0,
              y: -(element.scale.y / 2) - 1,
              z: 0
            };
            element.shape = selectedCutOut.shape === cut_outs_1.CutOutShapes.Round ? 'cylinder' : 'box';
            element.isSubstraction = true;
            break;

          case 'cut-out-assembly':
            element.position = {
              x: 0,
              y: 1,
              z: 0
            };
            break;

          case 'cut-out-trash':
            if (selectedCutOut.withRail) {
              element.position = {
                x: 0,
                y: -plate.scale.y,
                z: railDepthOffset
              }; // Under plate
            } else {
              element.position = {
                x: 0,
                y: -plate.scale.y - plate.position.y,
                z: 0
              }; // On the floor
            }

            break;
        }
      }
    }

    return elements;
  };

  return PlateElementsBuilder;
}();

exports.PlateElementsBuilder = PlateElementsBuilder; // I was going to try and break out all the elements, but realising it doesn't reduce code by much because of all the differences so maybe later